import styles from './AgentEditor.module.css';

interface FieldProps {
  label: string;
  hint: string;
  value: string;
  max: number;
  children: React.ReactNode;
}

/** A labelled input with its hint and a length meter. */
export function Field({ label, hint, value, max, children }: FieldProps): JSX.Element {
  return (
    <div className={styles.field}>
      <label className={styles.label}>{label}</label>
      {children}
      <div className={styles.help}>
        <span>{hint}</span>
        <span className={styles.metaRight}>
          <span className={styles.count}>
            {value.length}/{max}
          </span>
          <span className={styles.bar}>
            <span
              className={styles.barFill}
              style={{ width: `${String(Math.min(100, (value.length / max) * 100))}%` }}
            />
          </span>
        </span>
      </div>
    </div>
  );
}
